import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Users, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';

interface CreateFamilyPromptProps {
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

const CreateFamilyPrompt = ({ open, onOpenChange }: CreateFamilyPromptProps) => {
  const navigate = useNavigate();
  
  const handleCreateFamily = () => {
    if (onOpenChange) {
      onOpenChange(false);
    }
    navigate('/settings');
  };
  
  // Render the dialog if open prop is provided
  if (open !== undefined && onOpenChange) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Create a Family First</DialogTitle>
            <DialogDescription>
              You need to create a family group before adding children
            </DialogDescription>
          </DialogHeader>
          <div className="flex justify-center py-4">
            <Users className="h-16 w-16 text-primary/70" />
          </div>
          <p className="text-center mb-4">
            Children profiles are shared within your family group. Create a family in settings to get started.
          </p>
          <DialogFooter>
            <Button
              onClick={handleCreateFamily}
              className="w-full flex items-center justify-center gap-2"
            >
              Go to Family Settings
              <ChevronRight className="h-4 w-4" />
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
  
  // Otherwise render as a card
  return (
    <Card className="text-center p-6">
      <CardHeader>
        <div className="flex justify-center mb-4">
          <Users className="h-16 w-16 text-primary/70" />
        </div>
        <CardTitle>Create a Family First</CardTitle>
        <CardDescription>
          You need to create a family group before adding children
        </CardDescription>
      </CardHeader>
      <CardContent>
        <p className="mb-6">
          Children profiles are shared within your family group. Create a family in settings to get started.
        </p>
        <Button
          onClick={() => navigate('/settings')}
          className="w-full sm:w-auto flex items-center gap-2 mx-auto"
        >
          Go to Family Settings
          <ChevronRight className="h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
};

export default CreateFamilyPrompt;
